module.exports = __webpack_public_path__ + "static/media/gerenciamento_doc.5fabb207.svg";